












































































































import Vue, { VueConstructor } from 'vue';
import {
  PageTitle,
  CustomerSelectedInformation,
} from '../../common/components';
import { AxiosResponse, AxiosError } from 'axios';
import {
  AttendanceInformation,
  CustomersInformation,
} from '../../models/api-client';
import {
  CallCenterCustomerNumberParams,
  CustomersInformationVm,
  CustomerVm,
} from './viewModel';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import services from '../../services';
import mapper from './mappers';
import OpenCasesTable from '@/views/Customer/Cases/Open/components/OpenCasesTable.vue';
import CloseCasesTable from '@/views/Customer/Cases/Close/components/CloseCasesTable.vue';
import lang from '../../common/lang/de';
import EventBus from '@/event-bus';

const { CallCenterService, UserService } = services;

export default (Vue as VueConstructor<
  Vue & {
    $refs: {};
  }
>).extend({
  name: 'SelectedCustomer',
  components: {
    PageTitle,
    CustomerSelectedInformation,
    OpenCasesTable,
    CloseCasesTable
  },
  data() {
    return {
      callCenterCustomerNumber: {} as CallCenterCustomerNumberParams,
      selectedCustomerVm: mapper.createCustomerInformationVm() as CustomersInformationVm,
      dropdownTitles: [] as string[],
      panel: [true, false],
      dropdownTitlesCustomerInfo: [
        'Gewählter Kunde',
        'Rechnungsempfänger, WERBAS//KSR Vertragspartner'
      ] as string[],
      panelCustomerInfo: [true, false],
      osaRegistrationMsg: 'OSA-Registrierung NICHT vorhanden.' as string,
      notSupportRequestMsg: {
        visible: false as boolean,
        text: lang.selectCustomer.notSupportRequest as string
      },
      isCoCustomer: false as boolean,
      kindOfSupport: {
        values: [] as string[],
        isShowPrioCall: true as boolean,
        showComboSupport: false as boolean,
        supportSelected: '' as string,
      }
    };
  },
  created() {
    this.dropdownTitles.push('Laufende Support-Vorgänge');
    this.dropdownTitles.push('Kürzlich geschlossene Support-Vorgänge');
    this.callCenterCustomerNumber.customerNumber = parseInt(
      this.$route.params.id,
      10
    );

    this.getSelectedCustomer();
  },
  methods: {
    KsrSupport() {
      this.isCoCustomer = this.selectedCustomerVm.coCustomer != null;
      if (this.isCoCustomer) {
        this.setIsNewSupportDisable(this.selectedCustomerVm.coCustomer);
        this.notSupportRequestMsg.visible = !this.isCustomerUpdateBerechtigt(
          this.selectedCustomerVm.coCustomer
        );
      } else {
        this.setIsNewSupportDisable(this.selectedCustomerVm.customer);
        this.notSupportRequestMsg.visible = !this.isCustomerUpdateBerechtigt(
          this.selectedCustomerVm.customer
        );
      }
    },
    getSelectedCustomer() {
      this.$loader.show();
      CallCenterService.getSelectedCustomer(
        this.callCenterCustomerNumber.customerNumber
      )
        .then((result: AxiosResponse<CustomersInformation>) => {
          this.selectedCustomerVm = mapper.mapCustomerDtoToSelectedCustomerVm(result.data);
          localStorage.setItem(
            'callCenterSelectedCustomerNumber',
            this.selectedCustomerVm.customer.id.toString()
          );
          if (this.selectedCustomerVm.customer.osaGuid !== null) {
            this.osaRegistrationMsg = 'OSA-Registrierung vorhanden.';
            this.$store.dispatch(
              'user/setOsaId',
              this.selectedCustomerVm.customer.osaGuid.toLowerCase()
            );
          }
          this.loadKindSupport();
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        })
        .catch((err: AxiosError) => {
          if (
            err.response !== undefined &&
            (err.response.status === 401 || err.response.status === 500)
          ) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    setIsNewSupportDisable(customer: CustomerVm) {
      const disableBtn = !this.isCustomerUpdateBerechtigt(customer);
      EventBus.$emit('select-customer', disableBtn);
    },
    isCustomerUpdateBerechtigt(customer: CustomerVm) {
      return customer.updateBerechtigt && !customer.locked;
    },
    expandAttendanceCloseCase(props: any) {
      if (props.expanded) {
        UserService.getAttendanceCase(props.item.caseId)
          .then((result: AxiosResponse<AttendanceInformation[]>) => {
            const index = this.selectedCustomerVm.customer.closedCases.findIndex(
              selected => selected.caseId === props.item.caseId
            );
            this.selectedCustomerVm.customer.closedCases[
              index
            ].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(
              result.data
            );
          })
          .catch((err: AxiosError) => {
            if (
              err.response !== undefined &&
              (err.response.status === 401 || err.response.status === 500)
            ) {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.NotAuthorized);
              this.$router.push({ name: 'Index' });
            } else {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.UnexpectedError);
            }
          });
      }
    },
    expandAttendanceOpenCase(props: any) {
      if (props.expanded) {
        UserService.getAttendanceCase(props.item.caseId)
          .then((result: AxiosResponse<AttendanceInformation[]>) => {
            const index = this.selectedCustomerVm.customer.openedCases.findIndex(
              selected => selected.caseId === props.item.caseId
            );
            this.selectedCustomerVm.customer.openedCases[
              index
            ].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(
              result.data
            );
          })
          .catch((err: AxiosError) => {
            if (
              err.response !== undefined &&
              (err.response.status === 401 || err.response.status === 500)
            ) {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.NotAuthorized);
              this.$router.push({ name: 'Index' });
            } else {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.UnexpectedError);
            }
          });
      }
    },
    getUpdateText(updateValue: boolean): string {
      return updateValue ? 'Ja' : 'Nein';
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
    loadKindSupport() {
      const kinfOfSupportValues = this.$store.getters[
        'user/getKindOfSupport'
      ] as string[];
      const supportSelected = this.$store.getters[
        'user/getSupportSelected'
      ] as string;

      this.setKindSupport(kinfOfSupportValues);
      this.kindOfSupport.showComboSupport = kinfOfSupportValues.length > 1;
      this.kindOfSupport.supportSelected = supportSelected;
      this.changeKindSupport();
    },
    setKindSupport(kinfOfSupportValues: string[]) {
      kinfOfSupportValues.forEach(value => {
        value = value + '-Supportanfragen';
      });
      this.kindOfSupport.values = kinfOfSupportValues;
    },
    changeKindSupport() {
      if (this.kindOfSupport.supportSelected === 'GCS') {
        EventBus.$emit('select-customer', false);
        this.notSupportRequestMsg.visible = false;
      } else {
        this.KsrSupport();
      }
      this.$store.dispatch(
        'user/setSupportSelected',
        this.kindOfSupport.supportSelected
      );
    }
  }
});
